// Константы для Form3

// Функция для получения пустых данных формы
export const getEmptyFormData = () => {
  return {
    // Подлесок
    podlesok: [{
      id: 1,
      sostavpdl: '',        // Породы
      gustpdl: '',          // Густота
      hpdl: '',             // Средняя высота
      sostpdl: '',          // Состояние
      reljeff: '',          // Рельеф. Форма (справочник 21)
      reljefeksp: '',       // Рельеф. Экспозиция (справочник 17)
      reljefuklon: '',      // Рельеф. Уклон
      eroziavid: '',        // Эрозия. Вид (справочник 28)
      eroziastep: '',       // Эрозия. Степень (справочник 22)
      provlhm: '',          // Проведённые хозяйственные мероприятия (справочник 32)
      itaks3: ''            // Информация пользователя
    }],
    // Подрост
    podrost: [{
      id: 1,
      sostavpod: '',        // Состав
      vozrpod: '',          // Средний возраст (целое число до 999)
      hpod: '',             // Средняя высота (дробное число 3 знака до запятой, 1 после)
      gustpod: '',          // Густота, тыс. шт./га (как в МП: до 3 знаков до запятой, 2 после)
      sostpod: ''           // Состояние (справочник 23)
    }],
    form3ValidationErrors: true
  };
};

